import { call, put, take } from 'redux-saga/effects';

import * as errorActions from '../../errors/actions';
import * as actions from './actions';
import * as services from './services';

export function* parseNewsletterToken() {
  while (true) {
    try {
      const action = yield take(actions.PARSE_NEWSLETTER_TOKEN_REQUEST);

      const { token } = action.payload;

      const response = yield call(services.fetchGuardianContactNewsletter, { token });

      const [guardianContactNewsletter] = response.data;

      yield put(actions.parseNewsletterTokenSuccess({ guardianContactNewsletter }));
    } catch (error) {
      yield put(actions.parseNewsletterTokenFailure({ error }));

      yield put(errorActions.errorOccured({ error }));
    }
  }
}
